/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

const iconStyles = css`
  font-size: 16px;
`;

const Icon = ({
  name,
  type = 'fas',
  styles = css``,
  ...rest
}) => (
  <i
    className={`${type} fa-${name}`}
    css={[iconStyles, styles]}
    {...rest}
  />
);

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  styles: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
};

export default Icon;
